import { Flex, Separator, Stack, VStack } from '@chakra-ui/react';
import ContentIntro from '@src/components/sco/LayoutBlocks/ContentIntro';
import SectionWrapper from '@src/components/sco/LayoutBlocks/SectionWrapper';
import { PerksPage } from '@src/components/sco/Perks/Layout/PerksLayout';
import { PerksMainPanel } from '@src/components/sco/Perks/Layout/PerksMainPanel';
import { PartnerDealsHero } from '@src/components/sco/Perks/PartnerDealsHero';
import { PartnerList } from '@src/components/sco/Perks/PartnerList';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default PerksPage(function Page(props) {
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const activeContent = useActiveContentContext();
  useUniversalEffect(() => {
    activeContent.setSiteSection('perks.partners.landing');
  });
  return <PerksMainPanel>
      <Flex align={'start'} justify={'center'} width={'full'}>
        <Stack align={'center'} direction={'column'} gap={0} width={'full'}>
          {/* Hero */}
          <PartnerDealsHero />
          <Separator width={'full'} />
          <SectionWrapper bgColor={'colorPalette.panel'}>
            <VStack align={'center'} gap={getBreakpointValue([10, 10, 20])} width={'full'}>
              <ContentIntro title={'Every startup service you use, at a fraction of the price'} />
              <PartnerList />
            </VStack>
          </SectionWrapper>
        </Stack>
      </Flex>
    </PerksMainPanel>;
});